import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useOrganization } from '../hooks';

interface OrganizationFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
	disabled?: boolean;
}

export function OrganizationFormItem({
	required = true,
	disabled = false,
	fieldName
}: Readonly<OrganizationFormItemProps>): JSX.Element {
	const { items, organizationId } = useOrganization({ fieldName });

	return (
		<FormItem label="Company" name={fieldName} required={required} requiredMessage="The field requires an answer">
			<Select
				showSearch
				options={items}
				value={organizationId}
				placeholder="Company"
				disabled={disabled}
			/>
		</FormItem>
	);
}
